import {ContainerContents} from '@cypro/engine/database/schema'

export const containerContentsOptions = Object.values(ContainerContents.enum)

export const TradeNameFormDialogsIds = {
  assignStabilityRule: 'assign-stability-rule',
  addStabilityRule: 'add-stability-rule',
} as const
